import { render, staticRenderFns } from "./ColorPickersDemo.vue?vue&type=template&id=feda6f1e&"
import script from "./ColorPickersDemo.vue?vue&type=script&lang=js&"
export * from "./ColorPickersDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('feda6f1e')) {
      api.createRecord('feda6f1e', component.options)
    } else {
      api.reload('feda6f1e', component.options)
    }
    module.hot.accept("./ColorPickersDemo.vue?vue&type=template&id=feda6f1e&", function () {
      api.rerender('feda6f1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/forms/advanced-elements/ColorPickersDemo.vue"
export default component.exports